/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {listOauthExtensions} from '../api'

export const useMutationListOauthExtensions = createReactQueryMutationHook('listOauthExtensions', listOauthExtensions)
